<template>
  <div>
    <card v-if="bank_accounts.length">
      <!-- {{bank_accounts_data}} -->
      <b-row>
        <div>
            <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/>
        </div>
      </b-row>
      <b-row class="align-items-center py-4">
        <b-col md="12" >
          <b-table striped hover :items="bank_accounts_data" v-if="bank_accounts.length > 0" @row-clicked="handleEditRow" :fields="tableFields">
            <template #cell(account)="row">
              <!-- {{row.item}} -->
                <el-input v-model="row.item.account" :disabled="row.item.is_locked"></el-input>
            </template>
            <template #cell(bank_name)="row">
              <!-- {{row.item}} -->
                <el-input v-model="row.item.bank_name" :disabled="row.item.is_locked"></el-input>
            </template>
            <template #cell(swift)="row">
              <el-input v-model="row.item.swift" :disabled="row.item.is_locked"></el-input>
            </template>

            <template #cell(bank_address)="row">
              <!-- {{row.item}} -->
                <el-input v-model="row.item.bank_address" :disabled="row.item.is_locked"></el-input>
            </template>
            <!-- <template #cell(currency_code)="row">
                <el-select
                :disabled="row.item.is_locked"
                  v-model="row.item.currency_code"
                  filterable>
                  <el-option
                    v-for="option in currencies"
                    :key="option.code"
                    :label="option.code + ' (' + option.prefix + ')'"
                    :value="option.code">
                  </el-option>
                </el-select>
            </template> -->
            <template #cell(country_code)="row">
              <!-- {{row.item}} -->
                <el-select
                :disabled="row.item.is_locked"
                  v-model="row.item.country_code"
                  filterable>
                  <el-option
                    v-for="option in countries"
                    :key="option.code"
                    :label="option.name"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
            </template>
          </b-table>
        </b-col>
      </b-row>

    </card>
    <div class="floating-bar">
      <div class="floating-bar-container" align="center">
        <b-button-group>
            <b-button class="transparent-btn" @click="newBankAccounts" v-if="!showEditButton">
                <i class="fa fa-plus mr-2 text-success"></i>{{language_terms['ADD']}}
            </b-button>
            <b-button class="transparent-btn" @click="handleSaveRow" v-if="showEditButton">
                <i class="fa fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
            </b-button>
            <b-button class="transparent-btn" @click="handleCancelRow" v-if="showEditButton">
                <i class="fa fa-save mr-2 text-danger"></i>{{language_terms['CANCEL']}}
            </b-button>
            <b-button class="transparent-btn" @click="handleDeleteRow" v-if="showEditButton && showDeleteButton">
                <i class="fa fa-trash mr-2 text-warning"></i>{{language_terms['DELETE']}}
            </b-button>
        </b-button-group>
      </div>
    </div>
    <template v-if="0">
        <!--Add Button-->
        <a href="javascript:void(0)" class="float-button" @click="newBankAccounts" v-if="!showEditButton">
          <i class="fa fa-plus my-float-button"></i>
        </a>
        <!--Delete Button-->
        <a href="javascript:void(0)" class="float-button" @click="handleDeleteRow" v-if="showEditButton && showDeleteButton" style="background-color:#f5365c">
          <i class="fa fa-trash my-float-button"></i>
        </a> 
        <!--Cancel Button-->
          <a href="javascript:void(0)" class="float-button margin" @click="handleCancelRow" v-if="showEditButton" style="background-color:#fb6340">
            <i class="fa fa-times my-float-button"></i>
          </a>
        <!--Save Button-->
        <a href="javascript:void(0)" class="float-button mr-9" @click="handleSaveRow" v-if="showEditButton" style="background-color:#5e72e4">
          <i class="fa fa-check my-float-button"></i>
        </a>

    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Select, Option } from "element-ui";
import VueElementLoading from 'vue-element-loading'
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  props:{
    contact_id: {
      type: String,
      default: "-1",
      description: "Currency List",
      required: true,
    },
    contact_code: {
      type: String,
      default: "-1",
      description: "Contact Code",
      required: true,
    },
    currencies: {
      type: Array,
      default: function () { return [] },
      description: "Currency List",
      required: true,
    },
    countries: {
      type: Array,
      default: function () { return [] },
      description: "Country List",
      required: true,
    },
    bank_accounts:{
      type: Array,
      default: function () { return [] },
      description: "Bank Accounts",
      required: true,
    }
  },
  components: {
    VueElementLoading,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  watch: { 
      bank_accounts: function(newVal, oldVal) { // watch it
        this.bank_accounts_data = newVal
      },
      language_terms: {
          handler(val){
              this.updateTableLang()
          },
      }
    },
  computed: {
    ...mapState({
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      bank_account_id: (state) => state.bankAccounts.bank_account_id,
      bank_account_deleted: (state) => state.bankAccounts.is_deleted,
      bank_account_updated: (state) => state.bankAccounts.is_updated,

    }),
  },
  mounted(){
    this.bank_accounts_data = this.bank_accounts
    this.updateTableLang()
  },
  data() {
    return {
      loading:false,
      showDeleteButton:false,
      selected_index:-1,
      selected_row:{},
      bank_accounts_data:[],
      showEditButton: false,
      tableFields:[
          {
            key: 'account',
            label: "ACCOUNT",
            sortable: false,
            terms:"ACCOUNT"
          },

          {
            key: 'bank_name',
            label: 'BANK NAME',
            sortable: false,
            terms:"BANK_NAME"
          },
          {
            key: 'swift',
            label: 'SWIFT CODE',
            sortable: false,
            terms:"SWIFT_CODE"
          },
          {
            key: 'bank_address',
            label: 'BANK ADDRESS',
            sortable: false,
            terms:"BANK_ADDRESS"
          },
          {
            key: 'country_code',
            label: 'COUNTRY',
            sortable: false,
            terms:"COUNTRY"
          }
      ],
      // tableData: [],
    };
  },

  methods: {
       updateTableLang(){
      for(let i=0; i<this.tableFields.length;i++){
         let key = this.tableFields[i].terms
         this.tableFields[i].label = this.language_terms[key]

      }
    },

    newBankAccounts() {
      this.showDeleteButton = false
      this.selected_index = this.bank_accounts.length
      this.selected_row = {
        account: "",
        bank_name: "",
        swift:"",
        bank_address: "",
        country_code: "",
        is_locked: false,
      }
      this.bank_accounts_data.push({
        account: "",
        bank_name: "",
        swift:"",
        bank_address: "",
        country_code: "",
        is_locked: false,
      });



      this.showEditButton = true;
    },
    handleEditRow(row, index) {

      //console.log(this.showEditButton)

      if(this.showEditButton == false)
      {
          this.showEditButton = true;
          this.showDeleteButton = true;

          this.selected_index  = index
          this.selected_row = row

          //console.log(index)

          row.is_locked = false
            // this.bank_accounts[index].is_locked = false
          this.$set(this.bank_accounts_data, index , row) // Reactive table data

      }
      else
      {
         // alert("Please check, you haven't saved.")
          swal.fire({
            title: this.language_terms['ALTER_SAVE_CANCEL'],
            text: this.language_terms['ALTER_SAVE_CANCEL'],
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            icon: 'warning'
          })
      }
    },
   async handleCancelRow() 
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_CANCEL'] + '?', this.language_terms['CONFIRMATION'], {
        confirmButtonText: this.language_terms['YES'],
        cancelButtonText: this.language_terms['CANCEL'],
        type: 'warning'
        }).catch(() => {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') {
             this.loading = true
              let row = this.bank_accounts_data[this.selected_index]
              if(row.id == undefined || row.id == '' || row.id == null)
              {
                this.bank_accounts_data.splice(this.selected_index, 1)
              }

              this.bank_accounts_data.forEach(function (element) {
                    element.is_locked = true
              });
              this.showEditButton = !this.showEditButton;
              this.loading = false
        }
    },
    async handleSaveRow() 
    {
      this.loading = true
       this.showEditButton = false;

       if(this.selected_index != -1)
       {
          // console.log(this.selected_row)
          // console.log(this.selected_index)

          this.selected_row = this.bank_accounts_data[this.selected_index]
          this.bank_accounts_data[this.selected_index].is_locked = true

          if(this.selected_row.id)
          {
            this.updateBankAccount()
          }
          else
          {
            this.createBankAccount()
          }
       }
      this.loading = false

    },
    async createBankAccount()
    {
      this.loading = true
      this.selected_row.contact_id = this.contact_id
      this.selected_row.contact_code = this.contact_code
      await this.$store.dispatch("bankAccounts/create", this.selected_row)

      if(this.bank_account_id)
      {
        this.selected_row.is_locked = true
        this.selected_row.id = this.bank_account_id

      }
      else
      { 
        
        this.selected_row.is_locked = false
        this.showEditButton = true
      }
      this.$set(this.bank_accounts_data, this.selected_index , this.selected_row) 

      this.loading = false
        
    },
    async updateBankAccount()
    {
        this.loading = true

        this.selected_row.contact_id = this.contact_id
        this.selected_row.contact_code = this.contact_code
        await this.$store.dispatch("bankAccounts/update", this.selected_row)

        if(this.bank_account_updated)
        {
          this.selected_row.is_locked = true
        }
        else
        {
          this.selected_row.is_locked = false
          this.showEditButton = true
        }

        this.$set(this.bank_accounts_data, this.selected_index , this.selected_row) 


        this.loading = false

    },
    async handleDeleteRow() {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_DELETE'] + '?', this.language_terms['CONFIRMATION'], {
        confirmButtonText: this.language_terms['YES'],
        cancelButtonText: this.language_terms['CANCEL'],
        type: 'warning'
        }).catch(() => {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') {
              this.loading = true
              if(this.selected_row.id && this.selected_index != -1)
              {
                await this.$store.dispatch("bankAccounts/delete", this.selected_row)

                if(this.bank_account_deleted == 1)
                {
                    this.bank_accounts_data.splice(this.selected_index, 1);
                    this.bank_accounts_data.forEach(function (element) {
                          element.is_locked = true
                      });
                    this.showEditButton = false;
                }

              }
              this.loading = false
        }
     
    },
  },
};
</script>
<style scoped>
.margin{
  margin-right:80px;
}
</style>
